import { render, staticRenderFns } from "./CytomineTable.vue?vue&type=template&id=e1ff2cda&scoped=true"
import script from "./CytomineTable.vue?vue&type=script&lang=js"
export * from "./CytomineTable.vue?vue&type=script&lang=js"
import style0 from "./CytomineTable.vue?vue&type=style&index=0&id=e1ff2cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ff2cda",
  null
  
)

export default component.exports